import React, { useEffect, useState } from "react";
import { formatRupees, moneyFormatIndia } from "../../../../utils/inputsValidation";
import { FaEdit, FaRegEdit, FaUserEdit } from "react-icons/fa";
import axios from "axios";
import ExternalInvSwitchModal from "./modals/ExternalInvSwitchModal";
import Swal from "sweetalert2";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import { isAction } from "@reduxjs/toolkit";
import ActionModel from "./ActionModel2";
import { FaPlus, FaMinus } from "react-icons/fa";

import _ from "lodash";
import socket from "../../../../context/socket";
import api from "../../../../utils/api";
import { ActionFormModal } from "../modals/ActionFormModal";
import { useNavigate } from "react-router-dom";

const TabTwo = ({
  setSelectedTab,
  selectedTab,
  isEiPortfolio,
  roomId,
  fetchGetEiFolioData,
  isChecked,
  setIsChecked,
  loadingFolio
}) => {

  const [isPrst, setIsprst] = useState('Draft');
  
  const [isAllowedreview, setIsAllowedreview] = useState(false);
  const [showDiscardModal, setShowDiscardModal] = useState(false);
  const [isReason, setIsReason] = useState("");
  const [isRemark, setIsRemark] = useState("");
  const [openMobileCards, setOpenMobileCards] = useState({});

  const [isAllowdiscart, setIsAllowdiscart] = useState(false);
  const [isResent, setIsResent] = useState(false);
  const [isModalDiscardBtnMsg, setIsModalDiscardBtnMsg] = useState();
  const [showActionFormModal, setShowActionFormModal] = useState(false);

  const isEiReviews= isEiPortfolio?.eiReviews;
  const isEiInfo = isEiPortfolio?.eiInfo;
const navigate = useNavigate();
  const handleToggle = () => {
    setIsChecked((prev) => !prev); // Toggle state
  };


    

  useEffect(() => {
    if (isEiInfo) {
      // console.log("qqq", isEiInfo);

      setIsprst(isEiInfo?.portfolio_review_status);

      if (isPrst == "Draft" || isPrst == "Failed" || isPrst == "Rejected") {
        setIsAllowedreview(true);
        // console.log("Draft", isPrst);
      } else if (isPrst == "Sent" && isResent === false) {
        console.log("Sent", isPrst);
        setIsAllowdiscart(true);
      }
    }
  }, [isEiInfo, isPrst]);

  const [showExternalInvSwitchModal, setShowExternalInvSwitchModal] =
    useState(false);
  const [isGenerateSipForm, setGenerateSipForm] = useState({});
  const [isGenerateEIFormResponse, setGenerateEIFormResponse] = useState();
  const [viewPrErrors, setViewPrErrors] = useState([]);

  const [goalOptions, setGoalOptions] = useState();
  // console.log("goalOptions",  isEiInfo, goalOptions);


/////////////////////////////////////////////////////
  // When client executes from their side
   useEffect(() => {
      socket.on("execute", (msg) => {
        console.log("✅ Received Execute Data:", msg);
        if(msg?.data?.success==true){
          const nextUrl = `/refer-friends/?clientId=${roomId}`;
          socket.emit("navigate", { room: roomId, url: nextUrl });
          navigate(nextUrl);
          // fetchGetEiFolioData();
        }
        console.log("Transaction Data:", msg.data,msg,msg?.data?.success);
      });
      // Cleanup on unmount
      return () => {
        socket.off("execute");
      };
    }, []);
////////////////////////////////////////////////

  const handleBack = () => {
    if (selectedTab > 1) {
      setSelectedTab(selectedTab - 1);
    }
  };

  const eiValidateSubmit = async () => {
    try {
      const response = await api.post(
        `advisor/validateEiReviews`,
        {
          clientid: isEiInfo?.client_id,
          pr_id: isEiInfo?.portfolio_review_id,
          remark: "",
        }
      );

      console.log("validateEiReviews:", response.data);
      const obj = response.data;
      if (obj.isWarning == true) {
        Swal.fire({
          title: "Warning!",
          text: "Warning: Client is not enabled for online transactions.",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn ",
          },
        });
      } else if (obj.isError == false) {
        Swal.fire({
          title: "Success!",
          text: "Sent to Client for Approval.",
          icon: "success",
          showCancelButton: false,
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn ",
          },
        });
        fetchGetEiFolioData()
        socket.emit("join", { room: roomId });
        socket.emit("message_to",
          {
            room: roomId,
            data: {
              message: response?.data?.message || "Client data updated successfully",
              type: "success",
            }

          })
      } else {
        Swal.fire({
          text: obj.message,
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn ",
          },
        });
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to validate review. Please try again.",
        icon: "error",
        showCancelButton: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "swal-confirm-btn ",
        },
      });
      throw error;
    }
  };

  const eirechangeportfolio = async () => {
    setShowDiscardModal(true);
  };

  const handleDiscard = async (actionfrom) => {
    try {
      if (actionfrom == "submit") {
        // setIsDisableModalDiscardBtn(true);
      }
      const response = await api.post(
        `advisor/reeditEIPortfolio`,
        {
          clientid: isEiInfo?.client_id,
          pr_id: isEiInfo?.portfolio_review_id,
          discardremark: isRemark,
          discardReason: isReason,
          discartwhy: "",
          actionfrom: actionfrom,
        }
      );

      // console.log("reeditEIPortfolio:", response.data);

      const obj = response.data;
      if (obj.status === true) {
        if (actionfrom === "submit") {
          setShowDiscardModal(false);
          setIsReason("");
          setIsRemark("");
          Swal.fire({
            title: "Success",
            text: "Discarded Successfully.",
            // icon: "success",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "swal-confirm-btn",
            },
          });
          fetchGetEiFolioData()
          socket.emit("join", { room: roomId });
          socket.emit("message_to",
            {
              room: roomId,
              data: {
                message: response?.data?.message || "Client data updated successfully",
                type: "success",
              }

            })

        } else {
          // setIsDisableModalDiscardBtn(false);
        }
      } else {
        const object = obj.errors;
        setIsModalDiscardBtnMsg(object);
        // setIsDisableModalDiscardBtn(false);
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        title: "Server Error",
        text: "We encountered an issue while processing your request. Please contact support or try again later.",
        icon: "error",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "swal-confirm-btn",
        },
      });
    } finally {
      setIsRemark("");
      setIsReason("");
    }
  };

  const openEIsipform = async (item) => {
    console.log('amc_code',item);
    
    try {
      const {client_id: clientid,amcName,currentMktValue: currentval,schemeName: schemename,folio: portfolioid,
        isin: ISIN,goal_name: goalName,goal_id: goalId,amc: amc_code,} = item;

      const isSIP = "";
      const selectedText = `${schemename} ${portfolioid} <br> Current Value ${currentval}`;

      // Step 1: Generate EI Form
      const { data: formResponse } = await api.post(
        `advisor/generateEIForm`,
        {
          clientid,
          amcName,
          currentval,
          schemename,
          portfolioid,
          ISIN,
          goalName,
          goalId,
          isSIP,
          amc_code,
        }
      );
      console.log("amc_code",amc_code,formResponse);

      // Step 2: Set EI form modal state
      setGenerateEIFormResponse({ title: selectedText,body: formResponse,goalId,goalName,amc_code,rowData: item,});

      setShowExternalInvSwitchModal(true);

      // Step 3: Fetch Goal Data
      const { data: goalData } = await api.post(
        `advisor/getFormData`,
        {
          clientid,
          portfolioid,
          ISIN,
        }
      );

      setGenerateSipForm(goalData);

      console.log("Goal Dataitem:", item, goalData, formResponse);
    } catch (error) {
      console.error(
        "🔴 openEIsipform failed:",
        error.response?.data || error.message
      );
      // Optionally show user-friendly toast/message here
    }
  };

  const recommandedAction = async (inv) => {
    console.log("inv", inv);
    try {
      // Swal.fire({
      //   text: "Please wait...",
      //   imageUrl: 'https://www.finedge.in/assets/images/download.gif',
      //   showConfirmButton: false,
      //   allowOutsideClick: false,
      //   allowEscapeKey: false,
      // });

      const allData = {
        clientid: roomId,
        pr_row_id: inv.pr_row_id,
      }
      // API Call
      const response = await api.post(
        `advisor/view_pr_errors`,
        allData
      );
      //   console.log("view_pr_errors res",response.data);
      setViewPrErrors(response.data.data)

    } catch (error) {

      console.error("Error fetching portfolio data:", error);
      // Swal.fire({
      //   icon: 'error',
      //   title: 'Oops...',
      //   text: 'Failed to load portfolio data. Please try again later.',
      // });
    } finally {
      // Swal.close(); // Ensure the alert closes in both success and error cases
      setShowActionFormModal(true);

    }
  };

  const grandTotal = { invest: 0, current: 0, gain: 0 };

  const groupedReviews = _.groupBy(isEiReviews, "name");
  console.log("goruped reviewed", groupedReviews);
  if (Object.keys(groupedReviews).length === 0) {
    return (
      <Alert variant="success" className=" fw-bold d-block text-center mt-4">
        {loadingFolio ? "Loading..." :"No EI Review"}
      </Alert>
    );
  }

  const handelPushToArchive = async (prId) => {
    if (!prId) {
      await Swal.fire({
        icon: "error",
        title: "Missing PR ID"
      });
      return;
    }
  
    // Step 1: Confirm + get remark
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This will archive the portfolio review as 'Partially Executed'. Proceed?",
      icon: "warning",
      input: "textarea",
      inputPlaceholder: "Add a remark (required)",
      inputAttributes: {
        "aria-label": "Archive remark",
        maxlength: 500,
      },
      inputValidator: (v) => (!v?.trim() ? "Please enter a remark." : undefined),
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "No",
      reverseButtons: true,
      customClass: {
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    });
  
    if (!result.isConfirmed) return;
  
    const remark = result.value.trim();
  
    // Step 2: Show loader while calling API
    Swal.fire({
      title: "Archiving...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });
  
    try {
      const res = await api.post("advisor/eipushToArchive", {
        clientid: roomId,
        pr_id: prId,
        remark,
      });
  
      Swal.close();
  
      // ✅ Check archived response
      if (res?.data?.archived === "Passed") {
        await Swal.fire({
          icon: "success",
          title: "Archived",
          text: res?.data?.message || "Portfolio review archived successfully.",
        });
        fetchGetEiFolioData();
      } else if (res?.data?.archived === "Failed") {
        await Swal.fire({
          icon: "error",
          title: "Failed",
          text: res?.data?.message || "Portfolio review could not be archived.",
        });
      } else {
        await Swal.fire({
          icon: "warning",
          title: "Unexpected Response",
          text: JSON.stringify(res?.data) || "Server returned unknown status.",
        });
      }
    } catch (err) {
      Swal.close();
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: err?.response?.data?.message || err.message || "Something went wrong.",
      });
    }
  };

  
  return (
    <>
      <div className="scroll-container d-none d-md-block">
        <table className="table mb-5" >
          <thead>
       

            {/* Column Heading */}
            <tr className="green-bg">
              <th className="back-clrgreen txt-color-revers">
                Fund Name
              </th>

              <th className="back-clrgreen txt-color-revers">
                Inv Cost
              </th>

              <th className="back-clrgreen txt-color-revers">
                Current Value
              </th>

              <th className="back-clrgreen txt-color-revers">
                Gain/Loss
              </th>

              <th className="back-clrgreen txt-color-revers">
                Invested Through
              </th>

              <th className="back-clrgreen txt-color-revers text-center">
                Action
              </th>
            </tr>
          </thead>
          {isEiReviews?.map((investor, investorIndex) => {
            const investorTotals = { invest: 0, current: 0, gain: 0 };

            investor.exinvdata?.forEach((fund) => {
              fund.folios?.forEach((inv) => {
                const cost = Number(inv.costValue || 0);
                const current = Number(inv.currentMktValue || inv.currentval || 0);

                investorTotals.invest += cost;
                investorTotals.current += current;
                investorTotals.gain += current - cost;
              });
            });

            grandTotal.invest += investorTotals.invest;
            grandTotal.current += investorTotals.current;
            grandTotal.gain += investorTotals.gain;

            return (
          
              <>
                <tbody key={investorIndex}>
                  {/* Investor */}
                  <tr className="table-success">
                    <th colSpan={6}>
                      <h6 className="mb-0 fw-bold">
                        {investor.investorName}
                      </h6>
                    </th>
                  </tr>
                  {investor.exinvdata?.map((fund, fundIndex) => (
                    <React.Fragment key={fundIndex}>
                      {/* Fund Heading */}

                      <tr className="trbgcolor">
                        <th colSpan={6}>
                          {fund.fundName}
                        </th>
                      </tr>

                      {/* Folios */}

                      {fund.folios?.map((inv, idx) => {
                        const cost = Number(inv.costValue || 0);

                        const current = Number(
                          inv.currentMktValue || inv.currentval || 0
                        );

                        const gain = current - cost;

                        return (
                          <tr key={inv._id || idx}>
                            <td style={{ width: "30%" }}>
                              <div>
                                <span title={inv.schemeName}>
                                  {inv.schemeName}
                                </span>

                                {isAllowedreview &&
                                  isPrst === "Draft" && (
                                    <FaRegEdit
                                      className="clrgreen ms-2"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => openEIsipform(inv)}
                                    />
                                  )}

                                {inv.portfolio_type_sip === 1 && (
                                  <div className="small text-muted">
                                    (SIP)
                                  </div>
                                )}
                              </div>
                            </td>

                            <td>{formatRupees(cost)}</td>

                            <td>{formatRupees(current)}</td>

                            <td
                              className={
                                gain >= 0
                                  ? "text-success"
                                  : "text-danger"
                              }
                            >
                              {formatRupees(gain)}
                            </td>

                            <td>{inv.brokerName || "-"}</td>

                            <td
                              className="text-center"
                              style={{
                                cursor: inv.recommended_action
                                  ? "pointer"
                                  : "default",
                              }}
                              onClick={() => {
                                if (inv.recommended_action) {
                                  recommandedAction(inv);
                                }
                              }}
                            >
                              {inv.recommended_action?.replace(
                                /<[^>]*>/g,
                                ""
                              ) || "-"}
                            </td>
                          </tr>
                        );
                      })}
                    </React.Fragment>
                  ))}

                  <tr className="darkgreynew fw-bold">
                    <td>Fund Total</td>

                    <td>
                      {formatRupees(investorTotals.invest)}
                    </td>

                    <td>
                      {formatRupees(investorTotals.current)}
                    </td>

                    <td
                      className={
                        investorTotals.gain >= 0
                          ? "text-success"
                          : "text-danger"
                      }
                    >
                      {formatRupees(investorTotals.gain)}
                    </td>

                    <td colSpan={2}></td>
                  </tr>
                </tbody>

              </>
            )
          })}
          </table>
        
      </div>

      <div className=" d-none d-md-block mb-5">
        <div className="d-flex w-100 justify-content-between bg-light ps-2">
          <div style={{ width: "40%" }} className="fw-bold">
            Grand Total
          </div>
          <div className="fw-bold" style={{ width: "15%" }}>₹ {moneyFormatIndia(grandTotal.invest)}</div>
          <div className="fw-bold"style={{ width: "15%" }}>
          ₹ {moneyFormatIndia(grandTotal.current)}
            {/* {aandtotal ? Number(aandtotal)?.toFixed(2) : 0} */}
          </div>
          {/* <div className="fw-bold" style={{ width: "10%" }}>₹ {moneyFormatIndia(grandTotal.gain)}</div> */}
          <div className="fw-bold" style={{ width: "15%" }}>₹ {moneyFormatIndia((
            (Number(grandTotal.current) || 0) -
            (Number(grandTotal.invest) || 0)
          ).toFixed(2))}</div>
          <div style={{ width: "10%" }}></div>
          <div style={{ width: "20%" }}></div>
          <div style={{ width: "20%" }}></div>
          <div>
            <div></div>
          </div>
        </div>
      </div>
      {/* Mobile View */}
      <div className="d-block d-md-none">
        {isEiReviews?.map((investor, investorIndex) => {
          let investorCost = 0;
          let investorCurrent = 0;

          investor.exinvdata?.forEach((fund) => {
            fund.folios?.forEach((folio) => {
              investorCost += Number(folio.costValue || 0);
              investorCurrent += Number(folio.currentval || 0);
            });
          });

          const investorGain = investorCurrent - investorCost;

          return (
            <div
              key={investorIndex}
              className="card shadow-sm border-0 mb-4 rounded-4"
            >
              {/* Investor Header */}

              <div className="card-header bg-success text-white rounded-top-4">
                <h6 className="mb-2 fw-bold">
                  {investor.investorName}
                </h6>

                <div className="row text-center small">

                  <div className="col">
                    <div>Invested</div>
                    <strong>{formatRupees(investorCost)}</strong>
                  </div>

                  <div className="col">
                    <div>Current</div>
                    <strong>{formatRupees(investorCurrent)}</strong>
                  </div>

                  <div className="col">
                    <div>Gain</div>
                    <strong
                      className={
                        investorGain >= 0
                          ? "text-warning"
                          : "text-danger"
                      }
                    >
                      {formatRupees(investorGain)}
                    </strong>
                  </div>

                </div>
              </div>

              <div className="card-body p-2">

                {investor.exinvdata?.map((fund, fundIndex) => {

                  let fundCost = 0;
                  let fundCurrent = 0;

                  fund.folios?.forEach((folio) => {
                    fundCost += Number(folio.costValue || 0);
                    fundCurrent += Number(folio.currentMktValue || 0);
                  });

                  const fundGain = fundCurrent - fundCost;

                  return (

                    <div
                      key={fundIndex}
                      className="border rounded-3 mb-3"
                    >

                      {/* Fund Header */}

                      <div
                        className="bg-light p-3 fw-semibold"
                        style={{
                          borderBottom: "1px solid #eee"
                        }}
                      >
                        {fund.fundName}

                        <div className="small text-muted mt-1">

                          Current :
                          {" "}
                          {formatRupees(fundCurrent)}

                        </div>

                      </div>

                      {/* Folios */}

                      {fund.folios?.map((inv, idx) => {

                        const key =
                          `${investorIndex}-${fundIndex}-${idx}`;

                        const isOpen = openMobileCards[key];

                        const cost = Number(inv.costValue || 0);

                        const current = Number(
                          inv.currentMktValue || 0
                        );

                        const gain = current - cost;

                        return (

                          <div
                            key={idx}
                            className="border-top"
                          >

                            <div
                              className="d-flex justify-content-between align-items-center p-3"
                              style={{
                                cursor: "pointer"
                              }}
                              onClick={() =>
                                setOpenMobileCards((prev) => ({
                                  ...prev,
                                  [key]: !prev[key],
                                }))
                              }
                            >

                              <div>

                                <div
                                  className="fw-semibold"
                                  style={{
                                    fontSize: 14
                                  }}
                                >
                                  {inv.schemeName}
                                </div>

                                <small className="text-muted">
                                  {inv.brokerName}
                                </small>

                              </div>

                              <div>

                                {isOpen ? (
                                  <FaMinus className="text-danger" />
                                ) : (
                                  <FaPlus className="text-success" />
                                )}

                              </div>

                            </div>

                            {isOpen && (

                              <div className="px-3 pb-3">

                                <div className="d-flex justify-content-between mb-2">
                                  <span>Invested</span>
                                  <strong>
                                    {formatRupees(cost)}
                                  </strong>
                                </div>

                                <div className="d-flex justify-content-between mb-2">
                                  <span>Current</span>
                                  <strong>
                                    {formatRupees(current)}
                                  </strong>
                                </div>

                                <div className="d-flex justify-content-between mb-2">
                                  <span>Gain/Loss</span>

                                  <strong
                                    className={
                                      gain >= 0
                                        ? "text-success"
                                        : "text-danger"
                                    }
                                  >
                                    {formatRupees(gain)}
                                  </strong>

                                </div>

                                <div className="d-flex justify-content-between mb-2">
                                  <span>Broker</span>
                                  <strong>
                                    {inv.brokerName || "-"}
                                  </strong>
                                </div>

                                <div className="d-flex justify-content-between align-items-center mt-3">

                                  <span
                                    className="text-primary"
                                    style={{
                                      cursor:
                                        inv.recommended_action
                                          ? "pointer"
                                          : "default"
                                    }}
                                    onClick={() => {
                                      if (inv.recommended_action) {
                                        recommandedAction(inv);
                                      }
                                    }}
                                  >
                                    {inv.recommended_action?.replace(
                                      /<[^>]*>/g,
                                      ""
                                    ) || "-"}
                                  </span>

                                  {isAllowedreview &&
                                    isPrst === "Draft" && (

                                      <FaRegEdit
                                        className="text-success"
                                        style={{
                                          cursor: "pointer",
                                          fontSize: 18
                                        }}
                                        onClick={() =>
                                          openEIsipform(inv)
                                        }
                                      />

                                    )}

                                </div>

                              </div>

                            )}

                          </div>

                        );

                      })}

                    </div>

                  );

                })}

              </div>

            </div>
          );
        })}
      </div>

      <ExternalInvSwitchModal
        show={showExternalInvSwitchModal}
        isGenerateSipForm={isGenerateSipForm}
        isGenerateEIFormResponse={isGenerateEIFormResponse}
        onHide={(e) => setShowExternalInvSwitchModal(false)}
        roomId={roomId}
        isEiPortfolio={isEiPortfolio}
        fetchGetEiFolioData={fetchGetEiFolioData}
      />
      <div className=" text-center mt-5">
        {isAllowedreview === true && (
          <>
            {isPrst === "Draft" && (
              <button
                class="newBtn3 lrgbutton w-25 text-white uppercase ms-2 "
                id="eivalidatesubmit"
                onClick={(e) => eiValidateSubmit()}
              >
                Send
              </button>
            )}
            {(isPrst === "Failed" ||isPrst === "Rejected") && (
                <button
                  class="newBtn3 lrgbutton w-25 text-white uppercase ms-2 "
                  id="eivalidatesubmitresent"
                >
                  Resend
                </button>
              )}
          </>
        )}
        {isPrst === "Sent" && (
          <button
            class="newBtn3 lrgbutton w-25 text-white uppercase ms-2 bg-secondary"
            id="eirechangeportfolio"
            onClick={(e) => eirechangeportfolio()}
            // hidden={isHideDiscardBtn}
          >
            Discard
          </button>
        )}
        {(isEiInfo?.accepted_once
        //  && isEiInfo?.portfolio_review_status==='Processed'
        )&&  (
          <button
            class="newBtn3 lrgbutton w-25 text-white uppercase ms-2 "
            id="eipushToArchive"
            onClick={()=>handelPushToArchive(isEiInfo?.portfolio_review_id)}
          >
            Archive
          </button>
        )}
      </div>

      <ActionFormModal
            show={showActionFormModal}
            content={"No Form created"}
        onHide={() => { setShowActionFormModal(false); setViewPrErrors([])}}
            roomId={roomId}
        viewPrErrors={viewPrErrors} setViewPrErrors={setViewPrErrors}
          />

      <Modal show={showDiscardModal} onHide={(e) => setShowDiscardModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add Remarks</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="sipaction">Select Reason</Form.Label>
              <Form.Select
                id="sipaction"
                value={isReason}
                onChange={(e) => setIsReason(e.target.value)}
              >
                <option value="">Select Reason</option>
                <option value="Advisor Side Edit(s) Required">
                  Advisor Side Edit(s) Required
                </option>
                <option value="Partial Acceptance from Client">
                  Partial Acceptance from Client
                </option>
                <option value="Client Not Interested/Unresponsive">
                  Client Not Interested/Unresponsive
                </option>
                <option value="Declined by Client">Declined by Client</option>
              </Form.Select>
              {/* {errors.sipaction && (
 <small className="text-danger">{isModalDiscardBtnMsg}</small>
 )} */}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Remark</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Remarks"
                value={isRemark}
                onChange={(e) => setIsRemark(e.target.value)}
              />
            </Form.Group>

            {isModalDiscardBtnMsg && (
              <small className="text-danger">
                {isModalDiscardBtnMsg.eidiscardReason}
                {isModalDiscardBtnMsg.eicommon}
              </small>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="back-clrgreen"
            onClick={(e) => handleDiscard("submit")}
          >
            Discard
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TabTwo;
